import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import ProjectCard from "../../../components/consolecomponents/card/ProjectCard";
import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import DEAModal from "../../../components/consolecomponents/modal/DEAModal";
import NewProjectModal from "../../../components/consolecomponents/modal/NewProjectModalv2";

import "./Dashboard.styles.scss";
import exclamationcircleblue from "../../../Assets/exclamationcircleblue.svg";
import plus from "../../../Assets/plus.svg";
import arrowdown from "../../../Assets/arrowdown.svg";
import ConsoleFooter from "../../../components/consolecomponents/consolefooter/ConsoleFooter";
import IsLoading from "../../../util/loader/IsLoading";
import { useAllProjects, usePendingApps } from "../../../hooks/DevProjectHooks";
import PendingAppCard from "../../../components/consolecomponents/card/PendingAppCard";
import { orgStatus, projectStatus } from "../../../util/helpers/statusHelper";

import CustomModal from "../../../components/modal";
import FTUGuide from "../../../components/globalComponents/ftu-guide";
import ConsoleLocalStorage from "../../../storage/storage";
import { getFTUData, getProjAppCount } from "../../../util/helpers/funcHelper";
import { useGetOrg } from "../../../hooks/DevConsoleHooks";
import InvalidLicenseModal from "../../../components/InvalidLicenseModal";
import { CustomToast } from "../../../util/custom-toast/CustomToast";
import { useUser } from "../../../hooks/useUser";

const Dashboard = () => {
  const [showSideBarList, setShowSidebarList] = useState(false);
  const [showDEA, setShowDEA] = useState(false);
  const [showNewProject, setShowNewProject] = useState(false);
  const [projectid, setProjectid] = useState(null);
  const history = useHistory();
  const [showFTU, setShowFTU] = useState(false);
  const [ftuData, setFtuData] = useState(getFTUData("all"));
  const { data: org } = useGetOrg(ConsoleLocalStorage.getOrganization()?.id);
  const [showModal, setShowModal] = useState(false);
  const [isUserBlockedOrDeleted, setIsUserBlockedOrDeleted] = useState(false);
  const { user } = useUser();

  const handleCloseBlockedOrDeletedModal = () => {
    ConsoleLocalStorage.clearStorageExceptFTU();
    setIsUserBlockedOrDeleted(false);
    history.replace("/login");
  };

  const clearLocalStorage = () => {
    window.onbeforeunload = function (e) {
      ConsoleLocalStorage.clearStorageExceptFTU();
    };
  };

  const organization =
    localStorage.getItem("organization") &&
    JSON.parse(localStorage.getItem("organization"));

  useEffect(() => {
    if (org && Object.keys(org)?.length !== 0) {
      ConsoleLocalStorage.setOrganization(org);
    }
    if (org?.status === orgStatus.revoked.status) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [org?.status]);

  useEffect(() => {
    if (
      (user?.isBlocked && user?.isBlocked === true) ||
      (user?.isDeleted && user?.isDeleted === true)
    ) {
      setIsUserBlockedOrDeleted(true);
      clearLocalStorage();
    } else {
      setIsUserBlockedOrDeleted(false);
    }
  }, [user]);

  useEffect(() => {
    if (ConsoleLocalStorage.getFTU() === "true") {
      setShowFTU(true);
    }
  }, []);

  const {
    data: projects,
    isLoading: projectsLoading,
    isError: projectsError,
  } = useAllProjects();
  const {
    data: apps,
    isLoading: appsLoading,
    isError: appsError,
  } = usePendingApps(projects);
  if (projectsLoading || appsLoading) {
    return <IsLoading />;
  }

  /** whenever project create pressed then check if more project allowed then open modal else throw err */
  const openProjectModal = async () => {
    let { project } = await getProjAppCount(
      ConsoleLocalStorage.getOrganization().id
    );
    if (project.used >= project.allowed) {
      CustomToast(
        `You\'ve reached the limit of Projects for your license. \n
         Please upgrade your license to add more.
        `
      );
    } else {
      setShowNewProject(true);
    }
  };

  const handleCloseLicense = () => {
    ConsoleLocalStorage.clearStorageExceptFTU();
    setShowModal(false);
    history.replace("/login");
  };

  return (
    <>
      <DEAModal
        showDEA={showDEA}
        projectid={projectid}
        setShowDEA={setShowDEA}
      />
      <NewProjectModal
        showNewProject={showNewProject}
        setShowNewProject={setShowNewProject}
        showDEA={showDEA}
        setShowDEA={setShowDEA}
      />
      <CustomModal
        showModal={showFTU}
        setShowModal={setShowFTU}
        size="lg"
        isDismissible={false}
        rootClassName={"carousal"}
      >
        <FTUGuide
          showModal={showFTU}
          setShowModal={setShowFTU}
          data={ftuData}
        />
      </CustomModal>

      <div className="dashboard">
        <Sidebar>
          <section className="">
            <div
              onClick={() => setShowSidebarList(!showSideBarList)}
              className="sidebar_projects"
            >
              <h3 className="">
                {`All Projects (${projects?.length})`}
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>
              {showSideBarList ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) =>
                    project.status == projectStatus.draft.status ||
                    project.status == projectStatus.rejected.status ? (
                      <li
                        key={project.id}
                        onClick={() => {
                          setProjectid(project.id);
                          setShowDEA(true);
                        }}
                      >
                        <a>
                          <span className="sidebar_list_items">
                            {project.name}
                          </span>
                        </a>
                      </li>
                    ) : (
                      <li key={project.id}>
                        <Link to={`/console/${project.id}`}>
                          <span className="sidebar_list_items">
                            {project.name}
                          </span>
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              ) : null}
            </div>
          </section>
        </Sidebar>
        <div className="dashboard_main">
          <div className="">
            <div className="dashboard_heading">
              <h2>Dashboard</h2>
              <span
                className="text-dark-sky-blue c-pointer"
                onClick={() => {
                  setFtuData(getFTUData("project"));
                  setShowFTU(true);
                }}
              >
                How to get started?
                <img
                  src={exclamationcircleblue}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "1rem",
                    height: "1rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </span>
            </div>

            <div className="dashboard_projectpanel">
              <div className="dashboard_projectpanel-header">
                <h3 className="">
                  All Projects ({projects?.length}/
                  {organization?.projectAllowed
                    ? organization?.projectAllowed
                    : "-"}
                  )
                </h3>
                <h3>
                  All Apps (
                  {projects?.reduce(
                    (prev, project) => prev + project?.appCount,
                    0
                  )}
                  /{organization?.appsAllowed ? organization?.appsAllowed : "-"}
                  )
                </h3>
              </div>
              <div className="dashboard_projectpanel_body">
                <div
                  className=" dashboard_projectcreate"
                  onClick={() => openProjectModal()}
                >
                  <img
                    src={plus}
                    alt="logo"
                    className=""
                    style={{
                      width: "1rem",
                      height: "1rem",
                      marginLeft: "0.25rem",
                      marginBottom: "0.25em",
                    }}
                  />
                  Create new Project
                </div>
                {/* Project Lists */}
                {projects &&
                  projects.map((project) => (
                    <div
                      key={project.id}
                      onClick={() => setProjectid(project.id)}
                    >
                      <ProjectCard
                        data-testid="project-card"
                        project={project}
                        setShowDEA={setShowDEA}
                      />
                    </div>
                  ))}
              </div>
            </div>
            {/* Pending APP */}
            {apps && (
              <div className={"app_panel"}>
                <h4>Pending App Approvals ({apps?.length})</h4>
                <div className={"app_panel_main"}>
                  {apps && apps.length === 0 ? (
                    <h4
                      style={{
                        color: "#707070",
                        margin: "0 auto",
                        padding: "3em",
                        fontSize: "20px",
                      }}
                    >
                      No Pending App Approvals
                    </h4>
                  ) : (
                    apps &&
                    apps.map((app) => (
                      <div
                        key={app.id}
                        // onClick={() => handleCardClick(project.id, project.status)}
                      >
                        <PendingAppCard data={app} key={app.id} />
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
          <ConsoleFooter />
        </div>
      </div>
      <InvalidLicenseModal
        open={showModal}
        handleCloseLicense={handleCloseLicense}
      />
      <InvalidLicenseModal
        // title="This account is blocked or deleted"
        // description="Please check the account status"
        open={isUserBlockedOrDeleted}
        handleCloseLicense={handleCloseBlockedOrDeletedModal}
      />
    </>
  );
};

export default Dashboard;
